import { CONFIG } from '../../../constants';

const companyConfigConstants = {
  baseUrl: CONFIG.API_BASE_URL,

  tenantDataUpdateEndpoint: () => {
    return `/admin-config/`;
  },
};
export default companyConfigConstants;

export const SchedulerDefaultView = [
  { label: 'Day', value: 'day' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
];

export const SCHEDULER_FEATURE_TYPE = {
  schedularDefaultView: 'schedularDefaultView',
  schedularRTSreportFilter: 'schedularRTSreportFilter',
  schedularCardView: 'schedularCardView',
  showRefundedJobs: 'showRefundedJobs',
  showNewResourceList: 'showNewResourceList',
  schedulerDefaultStatus: 'schedulerDefaultStatus',
};

export const GLOBAL_SEARCH_OPTIONS = {
  lockVisibility: 'lockVisibility',
  globalSearchOptions: 'globalSearchOptions',
  clearGlobalSearchText: 'clearGlobalSearchText',
};

export const GLOBAL_FILTER_SECTION_ALLOWED_DATA_TYPES = [
  'text',
  'inputtext',
  'string',
  'email',
  'phone',
  'inputnumber',
  'inputtextarea',
  'textarea',
  'number',
];

export const SCHEDULER_CONFIG_DATA = {
  calender_view: {
    card_visibility: [],
  },
  show_refunded_jobs: 1,
  show_new_resource_list: 0,
};

export const SCHEDULER_CARD_VIEW_OPTIONS = [
  {
    options: [
      {
        value: { basic_labor_quantity: 'Basic Labor Quantity' },
        label: 'Basic Labor Quantity',
      },
      { value: { description: 'Description' }, label: 'Description' },
      { value: { time: 'Time' }, label: 'Time' },
      { value: { store: 'Store #' }, label: 'Store #' },
      { value: { project_type: 'Type' }, label: 'Type' },
      { value: { category: 'Category' }, label: 'Category' },
      { value: { status: 'Status' }, label: 'Status' },
      { value: { total_sale: 'Total Sale $' }, label: 'Total Sale $' },
      { value: { total_revenue: 'Total Revenue $' }, label: 'Total Revenue $' },
      { value: { project_number: 'Project No' }, label: 'Project No' },
      { value: { client_name: 'Client Name' }, label: 'Client Name' },
      { value: { address: 'Address' }, label: 'Address' },
      { value: { phone: 'Phone' }, label: 'Phone' },
      { value: { job_duration: 'Job Duration' }, label: 'Job Duration' },
      { value: { total_labor: 'Total Labor' }, label: 'Total Labor $' },
      {
        value: { source_category: 'Source Category' },
        label: 'Source Category',
      },
    ],
  },
  {
    type: {
      description: 'description',
      time: 'time',
      store: 'store',
      project_type: 'project_type',
      category: 'category',
      status: 'status',
      total_sale: 'total_sale',
      total_revenue: 'total_revenue',
      project_number: 'project_number',
      client_name: 'client_name',
      address: 'address',
      phone: 'phone',
      basic_labor_quantity: 'basic_labor_quantity',
      job_duration: 'job_duration',
      total_labor: 'total_labor',
      source_category: 'source_category',
    },
  },
];

export const ADDITIONAL_FEATURE_TYPE = {
  ALLOCATION_BEHAVIOUR: 'allocationBehaviour',
  ITEM_LINKAGE_CONFIGURATION: 'itemLinkageConfiguration',
  ACTIVE_JOBS_STATUS: 'activeJobsStatus',
  SALES_COMMISSION_OPTED: 'salesCommissionOpted',
  PROJECT_COLOR_CODE: 'projectColorCode',
  SKIP_TECHNICIAN_ASSIGNMENT_CLONING: 'skipTechnicianAssignmentCloning',
  GROUP_SOURCE_CATEGORY: 'groupSourceCategory',
  FIXED_TOP_BAR: 'fixedTopBar',
  FIXED_PROJECT_BAR: 'fixedProjectBar',
  SCHEDULER_CONFIG: 'schedulerConfig',
  CHARGEBACK_APPROVAL_MODULE: 'chargebackApprovalModule',
  RESET_PASSWORD_EXPIRE_IN: 'restPasswordExpireIn',
  MFA_EXPIRE_IN_DAYS: 'mfaExpireInDays',
  SHIPPING_AND_RECEIVING_MODULE: 'shipping_receiving',
  INVENTORY_MOBILE_APP_PERMISSION: 'inventory_mobile_app_permission',
  HIGHLIGHT_STORE_NOTES: 'highlight_store_notes',
  COPY_TOTAL_SALE: 'copy_total_sales',
  ADMIN_EMAIL: 'admin_email',
  DO_NOT_OVERRIDE_LABOR_COST: 'do_not_override_labor_cost',
  SHOW_LINE_ITEMS_ON_DOCUMENTS: 'show_line_items_on_documents',
  ASSIGN_TECHNICIAN_ON_REVENUE_EXCLUDED_ITEMS:
    'assign_technician_on_revenue_excluded_items',
  EPA_GUARDRAILS_WORKFLOW: 'epa_guardrails_workflow ',
  CATEGORY_SKILL_PERMISSION: 'category_skill_eligibility_permission',
  DOCUMENT_AUTO_PULL_RETRY: 'document_auto_pull_retry',
  PROJECT_NUMBER: 'personalized_private_project_number',
  RELATED_POS: 'related_pos',
  SEND_TENTATIVE_SCHEDULE_NOTE_TO_SOURCE:
    'send_tentative_schedule_note_to_source',
  PAYMENT_CONFIGURATION: 'payment_configuration',
  INCLUDE_ZERO_LABOR_COST_ITEMS_IN_PAYROLL_REPORT:
    'include_zero_labor_cost_items_in_payroll_report',
  SHOW_TAX_FIELDS_AT_PROJECT: 'show_tax_fields_at_project',
  AUTO_ASSIGN_TECHNICIANS: 'auto_assign_technicians',
  ORDER_COMPLETION_VALIDATION: 'order_completion_validation',
  Audit_log: 'audit_log',
  REMINDER_CONFIGURATION: 'reminder_configuration',
  SERVICE_TIME: 'service_time',
  EPA_LEAD_DOCUMENTATION: 'epa_lead_documentation',
  HOLD_EPA_LEAD_SUBMIT_ON_MOBILE: 'hold_epa_lead_submit_on_mobile',
  TECH_BASED_ON_RELATED_PO: 'tech_based_on_related_po',
  CUSTOM_TEMPLATE: 'custom_template',
  NOTES: 'notes',
  SALES_TAX: 'sales_tax',
  LOGO: 'logo',
  HOLD_ORDER_COMPLETION: 'hold_order_completion',
  SHOW_PROJECT_WITH_SAME_PROJECT_NUMBER:
    'show_projects_with_same_project_number',
  LINE_ITEM_VERIFICATION_GUARDRAILS: 'line_item_verification_guardrails',
  LINE_ITEM_PAYMENT_GUARDRAILS: 'line_item_payment_guardrails',
  SHOW_OLD_PROJECT_ITEMS: 'show_old_project_items',
  refreshToken: 'refresh_token',
  accessToken: 'access_token',
  remindLater: 'remind_later',
  QUOTE_CUSTOM_LAYOUT: 'quote_config',
  INVOICE_CUSTOM_LAYOUT: 'invoice_config',
  ASSIGN_TECHNICIAN_TO_PRODUCT_ITEM: 'assign_technician_to_product_item',
  COMPANY_PARENT_CHILD_ALLOCATION: 'company_parent_child_allocation',
  SKIP_TECHNICIAN_ASSIGNMENT_CLONING_PRODUCT:
    'skip_technician_assignment_cloning_product',
  TIME_SLOT_CONFIGURATION: 'time_slot_configuration',
  ZIP_CODE_ELIGIBILITY_PERMISSION: 'zipcode_eligibility_permission',
  INSTALLER_DELAY_ACCEPTED_TIME: 'installer_delay_accepted_time',
  TECHNICIAN_INVOICE_GUARDRAILS: 'technician_invoice_guardrails',
  OPPORTUNITY_INJECTION_FORM: 'opportunity_injection_form',
  IME_ESTIMATE_PERMISSION: 'ime_estimate_permission',
  ROUTE_OPTIMIZATION_CONFIGURATION: 'automated_ro_config',
  DYNAMIC_LAYOUT_CONFIGURATION: 'dynamic_layout_configuration',
  RTS_TABLE: 'rts_table',
};

export const ACTIVE_JOBS_DEFAULT_STATUS_NAMES = [
  'closed',
  'completed',
  'reassigned',
  'cancelled',
  'refunded',
];

export const commonPt = {
  content: {
    className: 'lg:pl-3 mt-3 lg:mt-0',
  },
  headertitle: {
    className: 'white-space-normal',
  },
};

export const companyConfigTableOptions = {
  field: 'label',
  header: 'Features',
  style: { width: '30%' },
};

export const RESET_PASSWORD_DAYS_OPTIONS = [
  { label: '30 Days', value: 30 },
  { label: '60 Days', value: 60 },
  { label: '90 Days', value: 90 },
  { label: '120 Days', value: 120 },
  { label: '180 Days', value: 180 },
];
export const MFA_EXPIRE_IN_DAYS_OPTIONS = [
  { label: 'Daily', value: 1 },
  { label: 'Weekly', value: 7 },
  { label: '15 Days', value: 15 },
  { label: 'Monthly', value: 30 },
  { label: '60 Days', value: 60 },
  { label: '90 Days', value: 90 },
  { label: '120 Days', value: 120 },
  { label: '180 Days', value: 180 },
];
export const DOCUMENT_EXPIRE_IN_DAYS_OPTIONS = [
  { label: '30 Days', value: 30 },
  { label: '60 Days', value: 60 },
  { label: '90 Days', value: 90 },
  { label: '120 Days', value: 120 },
  { label: '180 Days', value: 180 },
];

export const JOB_ASSIGNMENT_ROTATION_VALUES = [
  { id: 1, value: 'Default Store Technician' },
  { id: 2, value: 'Rotation Percentage' },
  { id: 3, value: 'Job Assignment Coverage' },
];
export const SERVICE_TIME_OPTIONS = [
  { name: 'Category Coverage', value: 'category_coverage' },
  { name: 'Item Coverage', value: 'item_coverage' },
];
export const AUTHENTICATION_METHOD_OPTIONS = [
  { name: 'All', value: 'all' },
  { name: 'Username & Password', value: 'username_and_password' },
  { name: 'Pin', value: 'pin' },
  { name: 'Microsoft Entra SSO', value: 'entra' },
];

export const COUNTRY_OPTIONS = [
  { label: 'US ( TAX )', value: 'US' },
  { label: 'Canada ( GST )', value: 'Canada' },
];

export const DEFAULT_COUNTRY = 'US';
export const HOLD_EPA_LEAD_SUBMIT_ON_MOBILE_FIELDS = {
  enabled: 0,
  project_type_ids: [],
  project_category_ids: [],
};
